module.exports = __webpack_public_path__ + "img/icon-package-ekyc-micro-light.f670131.svg";